/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningGoodlistReference
 */
export interface ApiScreeningGoodlistReference {
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningGoodlistReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningGoodlistReference
     */
    details?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningGoodlistReference
     */
    sanctionAlertId: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningGoodlistReference
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiScreeningGoodlistReference
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the ApiScreeningGoodlistReference interface.
 */
export function instanceOfApiScreeningGoodlistReference(value: object): value is ApiScreeningGoodlistReference {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sanctionAlertId' in value) || value['sanctionAlertId'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function ApiScreeningGoodlistReferenceFromJSON(json: any): ApiScreeningGoodlistReference {
    return ApiScreeningGoodlistReferenceFromJSONTyped(json, false);
}

export function ApiScreeningGoodlistReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningGoodlistReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'details': json['details'] == null ? undefined : json['details'],
        'sanctionAlertId': json['sanctionAlertId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function ApiScreeningGoodlistReferenceToJSON(json: any): ApiScreeningGoodlistReference {
    return ApiScreeningGoodlistReferenceToJSONTyped(json, false);
}

export function ApiScreeningGoodlistReferenceToJSONTyped(value?: ApiScreeningGoodlistReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'details': value['details'],
        'sanctionAlertId': value['sanctionAlertId'],
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

